export function resetPasswordValidator(values) {
  const errors: any = {};

  if (!values.password) {
    errors.password = "Password is required.";
  } else if (values.password.length < 8) {
    errors.password = "Password must have minimum 8 characters.";
  } else if (values.password.length > 15) {
    errors.password = "Password maximum length should be 15 characters.";
  }

  if (
    values.password_confirmation &&
    values.password !== values.password_confirmation
  ) {
    errors.password = "Password confirmation doesn't match";
    errors.password_confirmation = 1;
  }

  return errors;
}
